import React, { useState } from "react";
import { useNavigate,Link } from "react-router-dom";
import ContactPage from '../../../components/Global/BannerCard/DynamicHeader/ContactPage1';
import { Helmet } from "react-helmet-async";

const NetWork = () => {
  const navigate = useNavigate();
  const [showMore1, setShowMore1] = useState(false);
  const [showMore2, setShowMore2] = useState(false);

  return (
    <div className="w-full bg-white text-gray-800">

      <Helmet>
        <title>Adithya Infinity</title>
        <meta
          name="description"
          content="Adithya Infinity Pvt. Ltd. helps job seekers and students get placed in IT and Non-IT roles through internships, client projects, and skill guidance."
        />
        <meta
          name="keywords"
          content="Adithya Infinity, IT Jobs, Non-IT Jobs, Internships, Job Training, Client Projects, Placement Assistance, Software Jobs, Fresher Internships"
        />
        <meta name="author" content="Adithya Infinity Pvt. Ltd." />
        <meta name="robots" content="index, follow" />

        <meta property="og:title" content="Adithya Infinity Pvt. Ltd." />
        <meta
          property="og:description"
          content="Explore jobs, internships, and training with Adithya Infinity. Build your career with real client projects."
        />
        <meta
          property="og:image"
          content="https://img.freepik.com/free-photo/medium-shot-people-working-office_23-2150323516.jpg"
        />
        <meta property="og:url" content="https://yourdomain.com" />
        <meta property="og:type" content="website" />

        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "Organization",
            name: "Adithya Infinity Pvt. Ltd.",
            url: "https://yourdomain.com",
            logo: "https://yourdomain.com/logo.png",
            sameAs: [
              "https://www.linkedin.com/company/adithya-infinity",
              "https://www.facebook.com/adithya-infinity"
            ],
            contactPoint: {
              "@type": "ContactPoint",
              telephone: "+91-XXXXXXXXXX",
              contactType: "Customer Service"
            }
          })}
        </script>
      </Helmet>

      <ContactPage
        title="OUR NETWORK"
        subTitle="A global network powering innovation, collaboration, and excellence."
        backgroundImage="data:image/jpeg;base64,/9j/4AAQSkZJRgABAQAAAQABAAD/2wCEAAkGBw8NDw0NDQ0QDQ0NEBINDQ0NEBANDQ0NFRIWFhURFRUYHSggGBolGxUVITEhJSkrOi4uFx8/OD84Nyg5OisBCgoKDg0NFQ0NFSsZFRkrLS03LSsrKy03Ny0rKystLS03LS0rNy0tLS0tNysrLTc3Ny0tNystKy03Ny0tKy0tK//AABEIAKgBLAMBIgACEQEDEQH/xAAYAAEBAQEBAAAAAAAAAAAAAAAAAQIHA//EACYQAQAABQUAAgMBAQEAAAAAAAADMdHh8AIUQVOSARFRYcGhsSH/xAAVAQEBAAAAAAAAAAAAAAAAAAAAAf/EABQRAQAAAAAAAAAAAAAAAAAAAAD/2gAMAwEAAhEDEQA/AOIAKKACoAigApZFsAAC3LJfktyC3Vm/LWTAuJfkr+QU+/8Av8TJrX8/oEVMmZMD7/gnxn/pkwLFyxcAABAARUAAFQBAAAAUURQAMmCiZMyYirbhMmW5BS3Bky3IBbgyZbkFvwJflcmBklyTOTWv5AyS1/jOTWv5/QGSEyZkwW3CZItyZMC3BfgtyX5AQyZkwATJgqGTBT5D5QABABAUAFEVQABRARSwW5BSxk0tyCljJluQLr9pfkyYH2qZMyYC5/iZMyf6ADJmTAsFuTJgWLluUvyCoZMyYAICoAoCIAAAICgAAAoCioAKBbkQWyZMyYKJk1yYFxL8rkwBMmuTAM/xMmuTAEya5MCwmTMmC5JDJmTADJgCAKAAICAACAAoAAAKIKKAClkAUQEUEBbqyoKIAKgAqAAAAgCoAoAAIAAIAIAioDQn2AoCgAgogCgKKgAomTAFQEUTJgKIuTAEyagCAAZMFAAEVEFQFAABPtUQQABftAGkAFAAABRAFEUAD7UFQAVAAABUAAAAQFQAAEAEBU+w+wPtAAAAABfg+EX4BRPgBRBRQEBUFFEEFEFFEEFEFFEEFEAAAAAAQFD7T7A+flFQAAAAAAAAFEAVWVBRFAAAAAAAAAAAAAAAAABAVBAUQAAAAABAURQAAAAAAFQBVZUFEAURfkARQBFAE+AFEAAAEAFQAAAAAAQAAHvs4vTE8aqGzi9MTxqoAGzi9MTxqouzi9MTxqogC7OL1RPGqhs4vTE8aqABs4vTE8aqGzi9MTxqoAGzi9MTxqobOL0xPGqgAbOL0xPGqhs4vTE8aqABs4vVE8aqGzi9UTxqoAGzi9UTxqobOL1RPGqgAbOL1RPGqhs4vVE8aqABs4vVE8aqGzi9UTxqoAGzi9UTxqobOL1RPGqgAbOL1RPGqhs4vVE8aqABs4vTE8aqGzi9MTxqoAGzi9MTxqobOL0xPGqgAbOL0xPGqhs4vTE8aqABs4vTE8aqGzi9UTxqogC7OL1RPGqibOL0xPGqgAbOL0xPGqhs4vTE8aqABs4vTE8aqGzi9MTxqoAP/9k="
        highlightWord="NETWORK"
      />

      {/* Section: Network Headline */}
      <section className="w-full py-16 text-center bg-white">
        <h1 className="text-2xl md:text-3xl font-bold text-black">
          Powering Careers Through a Nationwide Network
        </h1>
        <p className="mt-2 text-sm text-gray-600 max-w-xl mx-auto">
          Adithya Infinity Pvt. Ltd. connects skilled professionals to growing businesses across IT and Non-IT sectors.
        </p>
      </section>

      {/* Section: Key Services Cards */}
<section className="bg-[#4db3c7] py-10">
  <div className="max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-3 gap-6 px-4 text-center">
    {["IT Job Access", "Non-IT Workforce", "Placement Solutions"].map((title) => (
      <Link
  key={title}
  to="/joblist"
  className="bg-white text-black p-6 rounded-lg shadow-md cursor-pointer hover:shadow-xl transition block"
>
  <div className="text-4xl mb-2">🌐</div>
  <h3 className="font-bold text-lg underline">{title}</h3>
  <p className="text-sm mt-2">
    Streamlining talent discovery and job access across multiple domains, skill levels, and cities.
  </p>
</Link>

    ))}
  </div>
</section>

      {/* Section: Image + Info */}
      <section className="bg-[#4db3c7] py-20">
        <div className="max-w-6xl mx-auto flex flex-col md:flex-row items-center justify-between px-4">
          <div className="relative w-[280px] h-[280px] md:w-[400px] md:h-[400px] mb-10 md:mb-0">
            <div className="absolute bg-[#b5e1e8] w-[200px] h-[200px] md:w-[280px] md:h-[280px] rounded-full -top-6 -left-6 z-0"></div>
            <div className="absolute bg-[#4db3c7] w-[180px] h-[180px] md:w-[260px] md:h-[260px] rounded-full -bottom-4 -right-4 z-0"></div>
            <img
              src="https://img.freepik.com/free-photo/medium-shot-people-working-office_23-2150323516.jpg"
              alt="Team working"
              className="relative z-10 rounded-full object-cover w-full h-full border-4 border-white shadow-lg"
            />
          </div>

          <div className="bg-white p-6 rounded-lg shadow-md max-w-md text-center md:text-left">
            <p className="text-xs font-semibold text-gray-500 mb-2">BUILD YOUR FUTURE</p>
            <h2 className="text-xl font-bold mb-4 text-black">
              Connect with our hiring experts and explore job opportunities that match your potential.
            </h2>
            <p className="text-sm text-gray-500 mb-2">
              Our advisors guide you through every step – from resume to placement.
            </p>
            <button
              onClick={() => navigate("/contact")}
              className="mt-4 px-6 py-2 rounded-full text-white bg-cyan-400 hover:bg-gray-800 transition"
            >
              Contact Us
            </button>
          </div>
        </div>
      </section>

      {/* Section: Focus Areas */}
      <section className="bg-[#4db3c7] py-16 text-center">
        <h2 className="text-2xl md:text-3xl font-bold mb-4 text-black">Focus Areas in Our Network</h2>
        <p className="text-sm max-w-xl mx-auto mb-10 text-black">
          We help companies and individuals grow in key professional domains.
        </p>
        <div className="max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-3 gap-6 px-4">
          {[
            { title: "Software & Cloud Roles", icon: "💻" },
            { title: "Customer Support & BPO", icon: "🎧" },
            { title: "Admin, HR & Sales Jobs", icon: "🧾" },
          ].map((item) => (
            <div key={item.title} className="bg-white text-black p-6 rounded-lg shadow-md">
              <div className="text-4xl mb-2">{item.icon}</div>
              <h3 className="font-bold text-lg">{item.title}</h3>
            </div>
          ))}
        </div>
      </section>

      {/* Section: Talent Collaboration & Onboarding */}
      <section className="relative bg-white py-20">
        <div className="absolute top-10 left-1/2 transform -translate-x-1/2 w-[300px] h-[300px] bg-[#b5e1e8] rounded-full opacity-50 z-0"></div>
        <div className="relative z-10 max-w-4xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-6 px-4">
          {/* Talent Collaboration */}
          <div className="bg-white p-4 rounded-lg shadow-md">
            <img
              src="https://img.freepik.com/free-photo/businesspeople-discussing-while-using-digital-tablet_53876-101882.jpg"
              alt="Collaboration"
              className="rounded-lg mb-4 w-full h-48 object-cover"
            />
            <h3 className="text-lg font-semibold text-black">Talent Collaboration</h3>
            <p className="text-sm text-gray-600 mt-2">
              We work with startups and enterprises to fulfill hiring goals through dedicated partnerships.
            </p>
            {showMore1 && (
              <p className="text-sm text-gray-600 mt-2">
                Our network simplifies access to pre-screened, job-ready candidates across India, enabling smarter hiring decisions at scale.
              </p>
            )}
            <button
              onClick={() => setShowMore1(!showMore1)}
              className="text-sm mt-3 inline-block text-black underline"
            >
              {showMore1 ? "Show Less" : "Learn More"}
            </button>
          </div>

          {/* Smarter Onboarding */}
          <div className="bg-white p-4 rounded-lg shadow-md">
            <img
              src="https://images.unsplash.com/photo-1630673470267-417e4d361129?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8NjM3fHxzb2Z0d2FyZXxlbnwwfHwwfHx8Mg%3D%3D"
              alt="Onboarding"
              className="rounded-lg mb-4 w-full h-48 object-cover"
            />
            <h3 className="text-lg font-semibold text-black">Smarter Onboarding</h3>
            <p className="text-sm text-gray-600 mt-2">
              From resume reviews to joining formalities, our support team stays engaged with every candidate.
            </p>
            {showMore2 && (
              <p className="text-sm text-gray-600 mt-2">
                We assist in coordinating training, induction, and documentation, reducing onboarding time and improving retention.
              </p>
            )}
            <button
              onClick={() => setShowMore2(!showMore2)}
              className="text-sm mt-3 inline-block text-black underline"
            >
              {showMore2 ? "Show Less" : "Learn More"}
            </button>
          </div>
        </div>
      </section>


      {/* Section: Resource Center */}
      <section className="py-20 bg-white text-center px-4">
        <div className="max-w-4xl mx-auto relative mb-12">
          <div className="absolute -top-8 -left-8 w-64 h-64 bg-[#b5e1e8] rounded-full z-0"></div>
          <div className="absolute -bottom-4 -right-4 w-24 h-24 bg-black rounded-full z-0"></div>
          <div className="relative z-10 bg-white p-6 rounded-lg shadow-lg max-w-md mx-auto">
            <img
              src="https://images.unsplash.com/photo-1552664730-d307ca884978?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8OTZ8fHNvZnR3YXJlfGVufDB8fDB8fHwy"
              alt="Library"
              className="rounded-lg mb-4 w-full h-48 object-cover"
            />
            <p className="text-xs font-semibold text-gray-500 mb-1">RESOURCE CENTER</p>
            <h3 className="text-xl font-bold mb-2 text-black">Explore Hiring Guides & Career Resources</h3>
            <p className="text-sm text-gray-600 mb-2">
              Our knowledge base helps candidates and companies stay aligned with industry trends.
            </p>
            <button
              onClick={() => navigate("/contact")}
              className="bg-cyan-400 text-white px-4 py-2 rounded-full hover:bg-gray-800 transition"
            >
              Connect Now
            </button>
          </div>
        </div>
      </section>

    </div>
  );
};

export default NetWork;
